"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPGRADE_DATA_VALID = exports.UPGRADE_DATA_INVALID = void 0;
var UPGRADE_DATA_INVALID = false;
exports.UPGRADE_DATA_INVALID = UPGRADE_DATA_INVALID;
var UPGRADE_DATA_VALID = true;
exports.UPGRADE_DATA_VALID = UPGRADE_DATA_VALID;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/upgradeData/upgradeDataStates.js
// module id = 455
// module chunks = 5 6